import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import { fetchTsIds } from './shared/parallelFetch'
import { useToFill } from './shared/useToFill'

export function useMonthlyNormals(ghId, tsIds) {
  const queryKey = ['monthlyNormals', ghId, tsIds]

  const { data, isLoading, isError } = useQuery({
    queryKey,
    queryFn: async () => {
      const empty = { data: [], to_fill: [] }
      const monthResp = await fetchTsIds(
        tsIds,
        tsId => api.get(`/sndata_ts?ts_id=${tsId}&gh_id=${ghId}&stype=MONTH`).catch(() => empty),
        true
      )
      const yearResp = await fetchTsIds(
        tsIds,
        tsId => api.get(`/sndata_ts?ts_id=${tsId}&gh_id=${ghId}&stype=YEAR`).catch(() => empty),
        true
      )
      const result = {
        monthNormals: monthResp.map(r => r?.data ?? []),
        yearNormals: yearResp.map(r => r?.data ?? []),
      }
      const toFill = [...monthResp, ...yearResp].flatMap(r => r?.to_fill ?? [])
      return { result, toFill }
    },
    enabled: !!ghId && tsIds.length > 0,
    staleTime: 60 * 60 * 1000,
  })

  useToFill(queryKey, data, (result, resp, item) => {
    const i = tsIds.indexOf(item.params?.ts_id)
    if (i < 0) return result
    const bucket = item.params?.stype === 'YEAR' ? 'yearNormals' : 'monthNormals'
    const next = result[bucket].slice()
    next[i] = resp.data
    return { ...result, [bucket]: next }
  }, { gran: 'MONTH', live: false })   // normály — dlouhodobé agregáty, nikdy „živé"

  const normalsMap = {}
  const yearNormalsMap = {}
  const R = data?.result
  if (R) {
    tsIds.forEach((tsId, i) => {
      normalsMap[tsId] = {}
      ;(R.monthNormals[i] ?? []).forEach(row => {
        if (row.sid) normalsMap[tsId][row.sid] = row.average ?? null
      })
      const yRows = R.yearNormals[i] ?? []
      yearNormalsMap[tsId] = yRows.length > 0 ? (yRows[0]?.average ?? null) : null
    })
  }

  return { normalsMap, yearNormalsMap, isLoading, isError }
}
